import React from 'react';
import type { FC } from 'react';
import type { UserInfo } from '@wix/cli-auth';
import { Text, ConfirmInput } from '@wix/cli-ui-kit';

interface Props {
  userInfo: UserInfo;
  onSubmit: (relogin: boolean) => void;
}

export const AlreadyLoggedIn: FC<Props> = ({ userInfo, onSubmit }) => {
  return (
    <>
      <Text>
        Wix CLI is currently logged in to account{' '}
        <Text skin="info">{userInfo.email}</Text>
      </Text>
      <ConfirmInput
        label={'Do you want to log in to a different account?'}
        initialValue={true}
        onSubmit={onSubmit}
      />
    </>
  );
};
